import { getIrr } from './IRR';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

export function calculateWirtschaftlichkeit(params: any, data: any, isExpert: boolean, daten?: any) {
    if (!daten) {
        daten = getTestDaten();
    }
    Moment().year();
    // Parameter
    const monat_inbetriebnahme = +params.pv_monat_inbetriebnahme || 1; // ----> IM STANDARD-MODU: AKTUELLER MONAT
    const jahr_inbetriebnahme = +params.pv_jahr_inbetriebnahme || Moment().year();

    const zins_diskontsatz = +params.pv_zins_diskontsatz || 0;
    const steuersatz_individuell = +params.pv_steuersatz_individuell || 0;
    const inflationsrate = +params.pv_inflationsrate || 0;
    const eeg_umlage_preis = +params.pv_eeg_umlage_preis || 0;
    const strompreis_steigerung = +params.pv_strompreissteigerung || 0;
    const strompreis_erstes_jahr = +params.pv_strompreis_erstes_jahr || 0;
    const ertragsminderung_pa = +params.pv_ertragsminderung_pa || 0;
    const einspeise_verguetung = getEinspeisungsverguetung(
        data, !isExpert, daten.technisch.anlagengroesse, jahr_inbetriebnahme, monat_inbetriebnahme
    );
    // const einspeise_verguetung = getMaxEinspeisungsverguetung(
    //     data, !isExpert, daten.technisch.anlagengroesse, jahr_inbetriebnahme, monat_inbetriebnahme
    // );
    // Eingangswerte
    const direktnutzung_solartag = daten.technisch.eigenverbrauchs_anteil / 100;
    const investitionskosten =  daten.wirtschaftlich.investitions_kosten;
    const eigenkapital = investitionskosten * 1.19;
    const anlagengroesse = daten.technisch.anlagengroesse;
    const ertrag_spezifisch = daten.technisch.ertrag;
    let restwert = investitionskosten;
    const laufende_kosten_basis = investitionskosten * 0.01; // 1% der Investitionskosten
    const vorlaufkosten = investitionskosten * 0.03; // 3% der Investitionskosten

    const logitem = {monat_inbetriebnahme, zins_diskontsatz, steuersatz_individuell, inflationsrate, eeg_umlage_preis,
                     strompreis_steigerung, strompreis_erstes_jahr, ertragsminderung_pa, einspeise_verguetung, direktnutzung_solartag,
                    };

    // console.log(logitem);

    let restwert1 = 0;
    let kapitalwert = 0;
    let summe_ammortisation = 0;
    let summe_ertrag_diskontiert = 0;
    let summe_laufende_kosten_diskontiert = 0;
    const arr_irr: Array<number> = [];

    const jahrStart = Moment().year();

    // Vorberechnungen
    const anteiliger_ertrag = getSolarErtrag(monat_inbetriebnahme);
    const eeg_umlage_satz = anlagengroesse <= 10 ? 0 :
                                (jahrStart < 2014 && monat_inbetriebnahme < 8) ? 0 :
                                    jahrStart < 2016 ? 0.3 :
                                        jahrStart < 2017 ? 0.35 : 0.4;

    const eeg_umlage_basis = eeg_umlage_satz * eeg_umlage_preis;
    for (let i = 0; i <= 20; i++ ) {
        const jahr = jahrStart + i;

    // *************** AFA UND RESTWERT **********************
        let afa;
        if (i === 0) {
            afa =  -1 * investitionskosten * 0.05 * (13 - monat_inbetriebnahme) / 12;   // Das 1. Jahr ggf. nur anteilig
            restwert = restwert + afa;
            restwert1 = restwert;
        } else {
            afa = -1 * restwert1 * 0.05;         // Hier nicht die Investitionskosten sondern den Restwert des 1 Jahres ? (!!!)
            restwert = restwert + afa;
        }
        // console.log('AFA/REST', restwert, afa);
    // *************** KOSTEN UND KAPITAL **********************
        let erzeugung;
        if (i === 0) {  // Im 1. Jahr ggf. anteilig
            erzeugung = anteiliger_ertrag * ertrag_spezifisch * anlagengroesse;
        } else {
            erzeugung = ertrag_spezifisch * anlagengroesse * ((1 - ertragsminderung_pa) ** i);
        }
        const direktnutzung = erzeugung * direktnutzung_solartag;
       // console.log('Erzeugung:', jahr, anlagengroesse,  ertrag_spezifisch, erzeugung, direktnutzung);

        let laufende_kosten;
        if (i === 0) {
            laufende_kosten = -1 * ( laufende_kosten_basis  * ((13 - monat_inbetriebnahme) / 12) + vorlaufkosten);
        } else {
            laufende_kosten = -1 * (laufende_kosten_basis  * ((1 + inflationsrate) ** i));
        }
        const eeg_umlage = direktnutzung_solartag * (anlagengroesse <= 30 ? 0 : 1) * eeg_umlage_basis * erzeugung;
        const eeg_verguetung = erzeugung * (1 - direktnutzung_solartag) * einspeise_verguetung;
        const direkt_verbrauch_einsparung = direktnutzung * strompreis_erstes_jahr * ((1 + strompreis_steigerung) ** i);
        let cashflow;
        if ( i === 0) {
            cashflow = eeg_umlage + eeg_verguetung + direkt_verbrauch_einsparung + laufende_kosten
                       - eigenkapital + 0.19 * (investitionskosten);
        } else {
            cashflow = eeg_umlage + eeg_verguetung + direkt_verbrauch_einsparung + laufende_kosten;
        }
        const steuerergebnis = afa  + laufende_kosten + eeg_umlage + eeg_verguetung + direkt_verbrauch_einsparung;
        const steuerwirkung = steuerergebnis * steuersatz_individuell * -1;
        const cashflow_nach_steuer = cashflow + steuerwirkung;

        const zins_fakt = ( 1 + zins_diskontsatz) ** i;

        const barwert = cashflow_nach_steuer / zins_fakt;
        kapitalwert =  kapitalwert + barwert;
        /*if (anlagengroesse === 5) {
            // console.log('AFA/REST', anlagengroesse, jahr, cashflow, cashflow_nach_steuer, afa, restwert);
            console.log('Kapitalwert ', jahr, kapitalwert, barwert, cashflow_nach_steuer, '-->', i, zins_diskontsatz, zins_fakt);

        }*/

        //
    // *************** ERTRAG UND AMMORTISATION **********************
        const ertrag_diskontiert =  erzeugung / zins_fakt;
        const laufende_kosten_diskontiert =  laufende_kosten / zins_fakt;

        const wert_ammortisation = (kapitalwert < 0) ? 1 : 0;
        summe_ertrag_diskontiert += ertrag_diskontiert;
        summe_ammortisation += wert_ammortisation;
        summe_laufende_kosten_diskontiert += laufende_kosten_diskontiert * -1;
        arr_irr.push(cashflow_nach_steuer);
    }
    const intrener_zinsfuss = getIrr(arr_irr, 0);
    const stromgestehungs_kosten = (investitionskosten + summe_laufende_kosten_diskontiert) / summe_ertrag_diskontiert;

    daten.wirtschaftlich.ammortisation = summe_ammortisation;
    daten.wirtschaftlich.interner_zinsfuss = intrener_zinsfuss;
    daten.wirtschaftlich.stromgestehungs_kosten = stromgestehungs_kosten;
    daten.wirtschaftlich.einspeiseverguetung = einspeise_verguetung;

    // console.log('Amm: ', summe_ammortisation, intrener_zinsfuss, summe_laufende_kosten_diskontiert, stromgestehungs_kosten);
}

function getSolarErtrag( monat: number )  {
    const arr: Array<number> = [];
    arr[1] = 0.9900;
    arr[2] = 0.9605;
    arr[3] = 0.9060;
    arr[4] = 0.8155;
    arr[5] = 0.6870;
    arr[6] = 0.5375;
    arr[7] = 0.3840;
    arr[8] = 0.2400;
    arr[9] = 0.1305;
    arr[10] = 0.0635;
    arr[11] = 0.0275;
    arr[12] = 0.0080;
    return arr[monat];
}

function getEinspeisungsverguetung(data: any, maxToday: boolean, anlagengroesse: number, j: number, m: number): number {
    if (+anlagengroesse <= 0) {
        return 0;
    }
    const limits: Array<number> = [10, 40];
    let result: number = 0;
    limits.forEach((limit: number, index: number) => {
        const last: number = limits[index - 1] || 0;
        if (anlagengroesse <= last) {
            return;
        }
        const diff: number = limit - last;
        let factor: number = anlagengroesse >= limit ? diff : (anlagengroesse > last ? anlagengroesse - last : 0);
        result += factor * getMaxEinspeisungsverguetung(data, maxToday, limit, j, m);
        if (index === (limits.length - 1) && anlagengroesse > limit) {
            factor = anlagengroesse - limit;
            result += factor * getMaxEinspeisungsverguetung(data, maxToday, limit + 1, j, m);
        }
    });
    return result / anlagengroesse;
}

function getMaxEinspeisungsverguetung(data: any, maxToday: boolean, anlagengroesse: number, j: number, m: number): number {
    let key = 'wert_100';
    if (anlagengroesse <= 40) {
        key = 'wert_40';
    }
    if (anlagengroesse <= 10) {
        key = 'wert_10';
    }
    const today = new Date().getTime();
    let maxStamp = 0;
    let foundDirect = -1;
    let value = 0;
    (data[IDs.ENT_EEG_VERGUETUNG] || []).forEach((element: any) => {
        const jahr = element.jahr;
        const mon = element.monat;
        const d = new Date(jahr, mon , 1).getTime();
        if (jahr === j && mon === m) {
            foundDirect = element[key];
        }
        if (d > maxStamp && (d < today || !maxToday)) {
            // console.log('MEV: ', element);
            maxStamp = d;
            value = element[key];
        }
    });
    if (foundDirect > 0 && !maxToday) {
        return foundDirect;
    } else {
        return value;
    }
}

function getTestDaten() {
    const obj: any =  {
        'technisch': {
          'stromverbrauch': 10000,
          'erzeugte_energie': 31521.25506072869,
          'netzeinspeisung': 26027.980378916516,
          'selbstverbrauch': 5493.274681812175,
          'netzbezug': 4506.557657129871,
          'eigenverbrauchs_anteil': 17.42720799418951,
          'autarkiegrad': 54.93274681812175,
          'anlagengroesse': 27,
          'dachflaeche': 300,
          'ertrag': 1050.7085020242896,
          'monate': [
            {
              'realer_verbrauch': 891.5039971306084,
              'reale_erzeugung': 1000.5019565956296,
              'diff': -108.99795946502313,
              'diff_nicht_negativ': 618.9829822901463,
              'selbstverbrauch': 272.52101484046204,
              'netzbezug': 618.9829822901463
            },
            {
              'realer_verbrauch': 797.0695207069585,
              'reale_erzeugung': 1547.553870507434,
              'diff': -750.4843498004732,
              'diff_nicht_negativ': 434.15724560826425,
              'selbstverbrauch': 362.9122750986943,
              'netzbezug': 434.15724560826425
            },
            {
              'realer_verbrauch': 853.569330613242,
              'reale_erzeugung': 2486.5214449743025,
              'diff': -1632.9521143610627,
              'diff_nicht_negativ': 370.33049064260547,
              'selbstverbrauch': 483.2388399706365,
              'netzbezug': 370.33049064260547
            },
            {
              'realer_verbrauch': 811.8472942098954,
              'reale_erzeugung': 3585.6979443317728,
              'diff': -2773.8506501218812,
              'diff_nicht_negativ': 280.0766201670225,
              'selbstverbrauch': 531.7706740428729,
              'netzbezug': 280.0766201670225
            },
            {
              'realer_verbrauch': 856.569283535393,
              'reale_erzeugung': 4201.446895162108,
              'diff': -3344.8776116267204,
              'diff_nicht_negativ': 239.60381037630094,
              'selbstverbrauch': 616.965473159092,
              'netzbezug': 239.60381037630094
            },
            {
              'realer_verbrauch': 793.1997953158601,
              'reale_erzeugung': 3971.23404199696,
              'diff': -3178.034246681092,
              'diff_nicht_negativ': 193.63565261076064,
              'selbstverbrauch': 599.5641427050995,
              'netzbezug': 193.63565261076064
            },
            {
              'realer_verbrauch': 811.669062146591,
              'reale_erzeugung': 4110.176807369004,
              'diff': -3298.5077452224027,
              'diff_nicht_negativ': 208.91813917841355,
              'selbstverbrauch': 602.7509229681775,
              'netzbezug': 208.91813917841355
            },
            {
              'realer_verbrauch': 825.4381650898673,
              'reale_erzeugung': 3739.2631076865464,
              'diff': -2913.8249425966565,
              'diff_nicht_negativ': 258.20612593366684,
              'selbstverbrauch': 567.2320391562005,
              'netzbezug': 258.20612593366684
            },
            {
              'realer_verbrauch': 806.3651217798373,
              'reale_erzeugung': 2910.9849858927355,
              'diff': -2104.6198641128967,
              'diff_nicht_negativ': 322.6375154457891,
              'selbstverbrauch': 483.7276063340482,
              'netzbezug': 322.6375154457891
            },
            {
              'realer_verbrauch': 856.5392913812916,
              'reale_erzeugung': 2169.1367838783517,
              'diff': -1312.5974924970635,
              'diff_nicht_negativ': 411.0687287601384,
              'selbstverbrauch': 445.4705626211532,
              'netzbezug': 411.0687287601384
            },
            {
              'realer_verbrauch': 826.4790403395868,
              'reale_erzeugung': 1096.863782811568,
              'diff': -270.3847424719761,
              'diff_nicht_negativ': 540.5147209793437,
              'selbstverbrauch': 285.96431936024317,
              'netzbezug': 540.5147209793437
            },
            {
              'realer_verbrauch': 869.5824366929132,
              'reale_erzeugung': 701.8734395222823,
              'diff': 167.70899717063006,
              'diff_nicht_negativ': 628.4256251374184,
              'selbstverbrauch': 241.15681155549487,
              'netzbezug': 628.4256251374184
            }
          ]
        },
        'wirtschaftlich': {
          'investitions_kosten': 33478.125895006466,
          'anlagenkosten': 1115.9375298335488
        }
    };
    return obj;
}
